import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import './Rating.css';

const Rating = ({ taskId, cleanerName, onSubmit }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating > 0) {
      onSubmit(taskId, rating, comment);
      setSubmitted(true);
    }
  };

  if (submitted) {
    return <div className="rating-submitted">Thank you for your feedback!</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="rating-form">
      <p>Rate {cleanerName}:</p>
      <div className="rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <FaStar
            key={star}
            className={`star ${star <= (hover || rating) ? 'active' : ''}`}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
          />
        ))}
      </div>
      
      <div className="form-group">
        <label>Comment (optional)</label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Share your experience..."
          rows="3"
        />
      </div>

      <button 
        type="submit" 
        className="btn btn-primary"
        disabled={rating === 0}
      >
        Submit Rating
      </button>
    </form>
  );
};

export default Rating;



